import http from '@/http-common'

export default {
  name: "SmetaTab",
  //  components: {SmetaTab},
  props: {
    ekp: {
      type: Object,
      required: true
    },
    smeta: {
      type: Object,
      required: true
    },
    summaEkp: {
      type: Number,
    },
    stateEkp: {
      type: String,
      required: true,
    }
  },
  created() {
    this.details = this.smeta.details
  },
  data() {
    return {
      details: [],
      selectMode: 'single',
      selected: [],
      costs: [],
      summaSmeta: 0,
      columns: [
        {key: 'cost', label: 'Статьи расхода', thClass: "bg-dark text-white"},
        {key: 'norma', label: 'Цена (норма)', thClass: "bg-dark text-white"},
        {key: 'summa', label: 'Цена (смета)', thClass: "bg-dark text-white"},
        {key: 'countPeople', label: 'Кол-во участ/шт', thClass: "bg-dark text-white"},
        {key: 'countDays', label: 'Кол-во дней/часов', thClass: "bg-dark text-white"},
        {key: 'itogoNorma', label: 'Итого (норма)', thClass: "bg-dark text-white"},
        {key: 'itogoSmeta', label: 'Итого (смета)', thClass: "bg-dark text-white"},
        // {key: 'returnSumm', label: 'Возврат'},
        {key: 'comment', label: 'Расшифровка', thClass: "bg-dark text-white"},
        {key: 'edit_field', label: '', thClass: "bg-dark text-white"},
      ],
      validSmeta: {
        cost: true,
        manager: true,
        resp: true,
        summaSmeta: true,
        normaSmeta: true,
        form: true
      },
    }
  },
  mounted() {
    this.loadCosts();
  },
  computed: {
    allSumma() {
      var det = this.details;
      var summ = 0;
      var vm = this;
      if (det) {
        det.forEach(function (x) {
          summ += parseFloat(x.summa * x.countPeople * x.countDays);
        })
        summ = summ.toFixed(2);
        vm.validSmeta.summaSmeta = true;
        if (summ > vm.summaEkp) {
          vm.validSmeta.summaSmeta = false;
        }
      }
      this.summaSmeta = summ
      return summ;
    },
  },
  methods: {
    iconVal: function (row) {
      if (row.detailsShowing) {
        return 'chevron-up';
      } else {
        return 'chevron-down';
      }
    },
    titleVal: function (row) {
      if (row.detailsShowing) {
        return 'Скрыть подразделы';
      } else {
        return 'Показать подразделы';
      }
    },
    titleLabel(rec) {
      if (rec.norma > 0 && rec.norma < rec.summa) {
        return 'Сумма превышает норму';
      } else {
        return ''
      }
    },
    checkSmeta() {
      var vm = this;
      this.validSmeta.cost = true;
      this.validSmeta.form = true;

      this.details.some(function (rec) {
        if (!rec.cost_id > 0) {
          vm.validSmeta.cost = false;
          vm.validSmeta.form = false;
        }
        if (rec.norma > 0 && rec.norma < rec.summa) {
          vm.validSmeta.normaSmeta = false;
          vm.validSmeta.form = false;
          return;
        }
      });

      if (!this.validSmeta.summaSmeta) {
        this.validSmeta.form = false;
      }
    },
    textLabel(rec) {
      return {
        'text-center text-danger': rec.norma > 0 && rec.norma < rec.summa,
        'text-center': rec.norma >= rec.summa || rec.norma <= 0
      }
    },
    summNormItog(rec) {
      var norm = rec.norma * rec.countPeople * rec.countDays;
      return norm;
    },
    summSmetaRow(rec) {
      var ss = rec.summa * rec.countPeople * rec.countDays;
      return ss;
    },
    changeSmetaRow(rec, index) {
      if (rec.norma > 0 && rec.norma < rec.summa) {
        this.details[index].summa = rec.norma;
      }
    },
    loadCosts() {
      var vm = this;
      var filt = '';
      // if (this.costParent_id != null)
      //     filt = "&parent_id="+this.costParent_id;
      http.get('/cost/list?event_kind_id=' + this.ekp.eventKindId + filt)
      .then((response) => {
        vm.costs = [];
        response.data.forEach(function (x) {
          x.value = x.id;
          x.text = x.analyticCode + ' - ' + x.nameCost;
          if (x.childs.length > 0) {
            x.disabled = true;
            vm.costs.push(x);
            x.childs.forEach(function (z) {
              z.value = z.id;
              z.text = ' - ' + x.nameCost + ' - ' + z.nameCost;
              vm.costs.push(z);
            })
          } else {
            vm.costs.push(x);
          }
        })
      })
      .catch((error) => console.log(error.response.data));
    },
    changeCost(rec, index) {
      const idx = this.costs.map(e => e.id).indexOf(rec.cost_id);
      if (idx >= 0) {
        var usePercent = this.costs[idx].usePercent;
        this.details[index].norma = this.costs[idx].norma;
        this.details[index].usePercent = usePercent;
      }
    },
    deleteRowDet(index) {
      this.details.splice(index, 1)
    },
    saveSmeta() {
      this.checkSmeta()
      if (this.validSmeta.form) {
        var smetaEkp = {}
        smetaEkp.details = this.details;
        smetaEkp.summaSmeta = this.summaSmeta;
        this.$emit('input', smetaEkp);
        this.$emit('closeSmeta');
      }
    },
    addSmetaRow() {
      var det = {
        id: 0,
        cost_id: 0,
        countPeople: 1,
        countDays: 1,
        summa: 0,
        comment: ''
      };
      if (!this.details || this.details == null) {
        this.details = [];
      }
      this.details.push(det);
    },
    getStateEkp() {
      return this.stateEkp == 'NEW' || this.stateEkp == 'DELETED'
    },
    checkFormatTrunc(value) {
      return Math.trunc(value)
    },
    checkFormat(value) {
      return value.replaceAll(',', '.')
    }
  }
}
